<script setup>
import { russiaMapNames } from "@/lib/russia";
import { computed, defineEmits, shallowRef, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

const emits = defineEmits({
  openPavilion: () => true,
});

const store = useStore();
const route = useRoute();
const showClue = shallowRef(false);
const isRussia = computed(() => ["russia"].includes(route.query.place));
const isAtom = computed(() => ["atom"].includes(route.query.place));
const showLoadingScreen = computed(
  () => store.state.application.showLoadingScreen
);
const currentLevelName = computed(() =>
  store.state.application.currentLevelName.trim()
);
const isRussiaPavilion = computed(() =>
  russiaMapNames.includes(currentLevelName.value)
);

const isGreen = computed(() => route.query.place === 'allPlace');

watch(showLoadingScreen, (screen) => {
  if (isAtom.value) return;
  if (!screen && (isRussia.value || isGreen.value)) {
    showClue.value = isGreen.value || (isRussiaPavilion.value &&
      currentLevelName.value !== russiaMapNames.at(-2));

    if (isRussiaPavilion.value) {
      emits("openPavilion");
    }
  }
}, { immediate: true });
</script>

<template>
  <Transition name="fade">
    <div v-show="showClue" class="clue">
      <img src="@/assets/new-icons/game/clue.svg" alt="" class="clue__icon" />
      <p v-if="!isGreen" class="clue__text">
        В МетаВДНХ представлены оригинальные аудиогиды по павльонам, которые
        были доступны в дни проведения Международной выставки-форума «Россия»
      </p>
      <p v-else class="clue__text">
        Контент предоставлен Комитетом Общественных Связей и Молодежной политики г. Москвы
      </p>
    </div>
  </Transition>
</template>

<style scoped>
.clue {
  position: absolute;
  bottom: 0.875rem;
  left: 10vw;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 10;
}

.clue__icon {
  width: 1.5rem;
  height: 1.5rem;
}

.clue__text {
  font-weight: 400;
  font-size: 0.62rem;
  letter-spacing: -0.01em;
  color: #fff;
  max-width: 17.56rem;
}
@media (max-width: 1000px) {
  .clue {
    bottom: 1.5rem;
    gap: 4px;
  }

  .clue__icon {
  width: 1rem;
  height: 1rem;
}

.clue__text {
  font-size: 0.45rem;
  max-width: 14rem;
}
}
</style>
